import { HTMLAttributeAnchorTarget } from "react";

import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import Image from "common/blocks/Image";
import RichText from "common/blocks/RichText";
import { ResolvedImage } from "resolvers/data/imageResolver";
import { ResolvedRichText } from "resolvers/data/richTextResolver";

import styles from "./QualityRow.module.scss";

const cx = classNames.bind(styles);

export type QualityRowProps = {
    components: {
        freeText: string;
        heading: string;
        highlights: ResolvedRichText;
        image: ResolvedImage;
        link: {
            href: string;
            linkText: string;
            target: HTMLAttributeAnchorTarget;
        };
    };
};

export const QualityRow = ({ components }: QualityRowProps) => {
    const { freeText, heading, highlights, image, link } = components;

    return (
        <div className={cx("qualityRow")}>
            <div className={cx("body")}>
                <div className={cx("summary")}>
                    <div className={cx("image")}>
                        <Image {...image} layout="fill" alt={image?.alt ?? heading} />
                    </div>
                    <div className={cx("content")}>
                        <div className={cx("heading")}>
                            <span className={cx("freeText")}>{freeText}</span>
                            <span className={cx("title")}>{heading}</span>
                        </div>
                        <div className={cx("actions")}>
                            <Button
                                theme="textLink"
                                href={link.href}
                                target={link.target}
                                ariaLabel={link.linkText}
                            >
                                {link.linkText}
                            </Button>
                        </div>
                    </div>
                </div>
                <RichText {...highlights} className={cx("highlights")} />
            </div>
        </div>
    );
};
